import { useEffect, useState } from "react";

import { cloudAuthDesktopV2 } from "../services/cloudAuthDesktopV2";

let cached: string[] | null = null;

export function useDesktopFeatureFlag(key: string): { enabled: boolean; loading: boolean } {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!cloudAuthDesktopV2.isSignedIn()) {
      setEnabled(false);
      setLoading(false);
      return;
    }
    const run = async () => {
      try {
        if (!cached) cached = await cloudAuthDesktopV2.getFeatureFlags();
        if (!cancelled) setEnabled(cached.includes(key));
      } catch {
        if (!cancelled) setEnabled(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void run();
    return () => {
      cancelled = true;
    };
  }, [key]);

  return { enabled, loading };
}

export function clearDesktopFeatureFlagCache() {
  cached = null;
}
